export interface MapCopy {
  /** The accessible name of the frame (and the title of the embedded map). */
  map: string;
  /** Shown on the contact page instead of the map while the owner has not added an embed link. */
  placeholder: string;
  /** The panel shown instead of the map until the visitor asks for it (loading the map contacts Google). */
  note: string;
  show: string;
  open: string;
  opensInNewTab: string;
}

export const content = {
  map: 'Map',
  placeholder: 'The map appears here once the owner adds an embed link.',
  note: 'The map comes from Google Maps: showing it connects your browser to Google.',
  show: 'Show the map',
  open: 'Open in Google Maps',
  opensInNewTab: '(opens in a new tab)',
} satisfies MapCopy;
